const env =
  window.location.hostname.split('.')[0] === "staging"
    ? 'staging'
    : window.location.hostname.split('.')[0] === "test"
      ? 'test'
      : ['localhost', '127.0.0.1', '0.0.0.0', '192.168.86.39', 'dev.genoplot.com'].includes(window.location.hostname)
        ? 'development'
        : 'production'

let isVite = false;
try {
isVite = import.meta.env ? true : false;
}
catch(err) {}
let envm = isVite ? import.meta.env : process.env;
// v6 config shape — the old v5 CLI-generated shape (region/userPoolWebClientId/
// oauth.socialProviders/single-string redirects) trips a
// "Cannot read properties of undefined (reading 'loginWith')" throw inside
// Amplify.configure → notifyOAuthListener when v6 auto-translates it. Emit
// the shape v6 expects directly to skip the translator.
const redirectSignIn =
  env === 'development'
    ? 'http://localhost:8080/'
    : env === 'staging'
      ? 'https://staging.genoplot.com/signin'
      : 'https://genoplot.com/signin'
const redirectSignOut =
  env === 'development'
    ? 'http://localhost:8080/'
    : env === 'staging'
      ? 'https://staging.genoplot.com/'
      : 'https://genoplot.com/'

const awsConfig = {
  Auth: {
    Cognito: {
      userPoolId: envm.VITE_aws_user_pools_id,
      userPoolClientId: envm.VITE_aws_user_pools_web_client_id,
      identityPoolId: envm.VITE_aws_cognito_identity_pool_id,
      // Optional: the cognito-idp-proxy Worker (infra/cloudflare/
      // cognito-idp-proxy) that corrects a username's case in flight.
      // Unset means Amplify talks to Cognito directly.
      ...(envm.VITE_cognito_idp_endpoint ? { userPoolEndpoint: envm.VITE_cognito_idp_endpoint } : {}),
      loginWith: {
        oauth: {
          domain: envm.VITE_authDomain,
          scopes: ['email', 'profile', 'openid', 'aws.cognito.signin.user.admin'],
          redirectSignIn: [redirectSignIn],
          redirectSignOut: [redirectSignOut],
          responseType: 'code',
          providers: ['Google', 'Apple', 'Facebook'],
        },
      },
    },
  },
}

export default awsConfig

